import React from "react";

// Icona outline fornita per Discorsi Pubblici, resa monocromatica tramite
// currentColor per rispettare gli stati visuali della sidebar.
const PublicTalkPodiumIcon = ({ title, ...props }) => (
  <svg
    viewBox="0 0 512 512"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="10"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden={title ? undefined : true}
    role={title ? "img" : undefined}
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path d="M227.8 266.13c53.69 0 97.38-49.86 97.38-111.14V89a57.88 57.88 0 0 0-57.81-57.82H138.15a7.72 7.72 0 0 0-7.73 7.72V155c0 61.27 43.68 111.13 97.38 111.13ZM145.87 46.6h121.5A42.41 42.41 0 0 1 309.73 89v66c0 52.76-36.75 95.68-81.93 95.68S145.87 207.75 145.87 155Z" />
    <path d="M362.13 398.69h-40.27a7.73 7.73 0 0 0 0 15.45h40.27a7.73 7.73 0 1 0 0-15.45Z" />
    <path d="M491.82 465.4H477V312.8a7.69 7.69 0 0 0-2.26-5.46l-51-51a36 36 0 0 0 8-22.48 36.35 36.35 0 1 0-36.35 36.35 35.92 35.92 0 0 0 16.32-4.05l49.88 49.84v149.39H415a4.63 4.63 0 0 0 .07-.52L407.33 347a7.72 7.72 0 0 0-3.3-5.84l-86.86-60.38a7.71 7.71 0 0 0-11.78 4l-42.61 136.34-12.57-74.73a30.83 30.83 0 0 0 8.66-21.48 31.22 31.22 0 1 0-62.44 0 30.87 30.87 0 0 0 8.66 21.48l-12.56 74.73-42.62-136.35a7.71 7.71 0 0 0-11.78-4l-86.86 60.34A7.75 7.75 0 0 0 48 347l-7.7 117.93c0 .18.07.34.07.52H20.18a7.73 7.73 0 1 0 0 15.45h471.64a7.73 7.73 0 1 0 0-15.45ZM374.54 233.87a20.9 20.9 0 1 1 20.9 20.89 20.92 20.92 0 0 1-20.9-20.89ZM63.15 351.67l75.16-52.25 49.11 157.14a7.9 7.9 0 0 0 7.9 5.41 7.74 7.74 0 0 0 7.09-6.43L221 344.77a7.73 7.73 0 0 0-2.91-7.41 15.63 15.63 0 0 1-6.24-12.45 15.77 15.77 0 0 1 31.54 0 15.63 15.63 0 0 1-6.24 12.45 7.75 7.75 0 0 0-2.91 7.41l18.62 110.77A7.74 7.74 0 0 0 260 462a8 8 0 0 0 7.9-5.41L317 299.42l75.16 52.25 7.43 113.73H55.72Z" />
  </svg>
);

export default PublicTalkPodiumIcon;
